<template>
    <div class="main">
        <section class="start">
            <div class="start-background"></div>

            <a class="start-home" href="https://www.grevin-paris.com/" target="_blank">
                <img src="@/assets/img/house.svg">
                Allez sur le site <span>grevin-paris.com</span>
            </a>
            <figure class="start-image">
                <img src="@/assets/img/logo-white.png" alt="Incroyable Grévin Paris">
            </figure>

            <div class="start-text">
                <p>
                    A l'occasion de nos 140 ans, <br>
                    profitez d'une programmation exceptionnelle et inédite&nbsp;!
                </p>
            </div>

            <Button v-bind:url="'https://www.grevin-paris.com/les-tarifs-permanents'" v-bind:title="'Achetez vos billets'" v-bind:target="'_blank'" />

            <!-- <div v-on:click="scrollToSlide(0)" class="start-to-scroll"></div> -->
        </section>

        <section
            v-for="section, index in sections"
            :class="['section', 'section--'+section.layout]"
            :key="index"
            :data-layout="section.layout"
        >
            <h2 class="title title-lg color-gold">{{ section.title }}</h2>
            <div class="section-date" v-if="section.date" v-html="section.date"></div>
            <div class="section-text" v-html="section.text"></div>

            <Button v-bind:url="section.button.url" v-bind:title="section.button.title" v-bind:target="'_blank'" />
        </section>

        <section class="end">
            <div class="end-background"></div>

            <div class="end-confetti">
                <div class="end-confetti-left"></div>
                <div class="end-confetti-right"></div>
            </div>

            <!-- <figure class="end-image">
                <img src="@/assets/img/logo.png" alt="Incroyable Grévin Paris">
            </figure> -->

            <h1 class="title title-xl color-gold">Grévin fête ses 140 ans !</h1>

            <div class="end-text">
                <p>
                    De la magie, du théâtre immersif, des concerts à la bougie ou encore du street art ; <br>
                    Cette année le musée Grévin met les petits plats dans les grands pour souffler ses 140 bougies <br>
                    du 12 avril au 31 décembre 2022.
                </p>
            </div>

            <div class="end-ml">Pour lancer les festivités</div>

            <Button v-bind:space="true" v-bind:url="'#'" v-bind:title="'Maintenez la barre d’espace'" />

            <Button v-on:click.native="kickOffTheFestivities" v-bind:url="'#'" v-bind:title="'Lancez les festivités'" />
        </section>

        <div class="blur"></div>

        <nav class="nav">
            <div
                v-for="section, index in sections"
                :class="['nav-item', 'item--'+section.layout]"
                :key="index"
                class="nav-item"
                v-on:click="scrollToSlide(index)"
            >{{ section.title }}</div>
        </nav>

        <div id="canvas-container"></div>
    </div>
</template>

<script>
import Button from './Button.vue'

import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import ScrollTo from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger, ScrollTo)

import MobileDetect from '../assets/js/mobile-detect'

export default {
    name: 'Page',
	components: {
		Button,
	},
    props: ['settings', 'sections'],
    data: function() {
        return {
            fworks: null,
            focus: true,
            scrollTrigger: null,
            mobileDetect: new MobileDetect,
            lockFire: false,
            scrollTl: null
        }
    },
    computed: {
        windowIsVisible () {
            return document.visibilityState == 'visible'
        }
    },
    mounted() {
        //
        // set app var
        //
        let app = this;


        //
        // scroll at bottom
        //
        setTimeout(() => {
            window.scrollTo(0, document.body.scrollHeight);
        }, 500);


        //
        // firework class
        //
        let Fireworks = function(){
            /*=============================================================================*/
            /* Utility
            /*=============================================================================*/
            var self = this;
            window.requestAnimFrame=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(a){window.setTimeout(a,1E3/60)}}();

            /*=============================================================================*/
            /* Initialize
            /*=============================================================================*/
            self.init = function(){
            self.dt = 0;
                self.oldTime = Date.now();
                self.canvas = document.createElement('canvas');
                self.canvasContainer = document.getElementById('canvas-container');

                // var canvasContainerDisabled = document.getElementById('canvas-container');
                self.canvas.onselectstart = function() {
                    return false;
                };

                self.canvas.width = self.cw = window.innerWidth;
                self.canvas.height = self.ch = window.innerHeight;

                // self.particles = [];
                // self.partCount = 30;
                // self.fireworks = [];
                // self.currentHue = 170;
                // self.partSpeed = 10;
                // self.partSpeedVariance = 5;
                // self.partWind = 50;
                // self.partFriction = 5;
                // self.partGravity = 1;
                // self.hueMin = 0;
                // self.hueMax = 360;
                // self.fworkSpeed = 10;
                // self.fworkAccel = 3;
                // self.hueVariance = 180;
                // self.flickerDensity = 50;
                // self.showShockwave = true;
                // self.showTarget = false;
                // self.clearAlpha = 100;

                for (let [key, value] of Object.entries(app.settings)) {
                    self[key] = value;
                }

                self.mx = self.cw/2;
                self.my = self.ch/2;

                self.canvasContainer.append(self.canvas);
                self.ctx = self.canvas.getContext('2d');
                self.ctx.lineCap = 'round';
                self.ctx.lineJoin = 'round';
                self.lineWidth = 3;
                self.bindEvents();
                self.canvasLoop();

                self.canvas.onselectstart = function() {
                    return false;
                };


            };

            /*=============================================================================*/
            /* Particle Constructor
            /*=============================================================================*/
            var Particle = function(x, y, hue){
                this.x = x;
                this.y = y;
                this.coordLast = [
                    {x: x, y: y},
                    {x: x, y: y},
                    {x: x, y: y}
                ];
                this.angle =app.rand(0, 360);
                this.speed =app.rand(((self.partSpeed - self.partSpeedVariance) <= 0) ? 1 : self.partSpeed - self.partSpeedVariance, (self.partSpeed + self.partSpeedVariance));
                this.friction = 1 - self.partFriction/100;
                this.gravity = self.partGravity/2;
                this.hue =app.rand(hue-self.hueVariance, hue+self.hueVariance);
                this.brightness =app.rand(50, 80);
                this.alpha =app.rand(40,100)/100;
                this.decay =app.rand(10, 50)/1000;
                this.wind = (app.rand(0, self.partWind) - (self.partWind/2))/25;
                this.lineWidth = self.lineWidth;
            };

            Particle.prototype.update = function(index){
                var radians = this.angle * Math.PI / 180;
                var vx = Math.cos(radians) * this.speed;
                var vy = Math.sin(radians) * this.speed + this.gravity;
                this.speed *= this.friction;

                this.coordLast[2].x = this.coordLast[1].x;
                this.coordLast[2].y = this.coordLast[1].y;
                this.coordLast[1].x = this.coordLast[0].x;
                this.coordLast[1].y = this.coordLast[0].y;
                this.coordLast[0].x = this.x;
                this.coordLast[0].y = this.y;

                this.x += vx * self.dt;
                this.y += vy * self.dt;

                this.angle += this.wind;
                this.alpha -= this.decay;

                if(this.alpha < .05){
                    self.particles.splice(index, 1);
                }
            };

            Particle.prototype.draw = function(){
                var coordRand = (app.rand(1,3)-1);
                self.ctx.beginPath();
                self.ctx.moveTo(Math.round(this.coordLast[coordRand].x), Math.round(this.coordLast[coordRand].y));
                self.ctx.lineTo(Math.round(this.x), Math.round(this.y));
                self.ctx.closePath();
                self.ctx.strokeStyle = 'hsla('+this.hue+', 100%, '+this.brightness+'%, '+this.alpha+')';
                self.ctx.stroke();

                if(self.flickerDensity > 0){
                    var inverseDensity = 50 - self.flickerDensity;
                    if(app.rand(0, inverseDensity) === inverseDensity){
                        self.ctx.beginPath();
                        self.ctx.arc(Math.round(this.x), Math.round(this.y),app.rand(this.lineWidth,this.lineWidth+3)/2, 0, Math.PI*2, false)
                        self.ctx.closePath();
                        var randAlpha = app.rand(50,100)/100;
                        self.ctx.fillStyle = 'hsla('+this.hue+', 100%, '+this.brightness+'%, '+randAlpha+')';
                        self.ctx.fill();
                    }
                }
            };

            /*=============================================================================*/
            /* Create Particles
            /*=============================================================================*/
            self.createParticles = function(x,y, hue){
                var countdown = self.partCount;
                while(countdown--){
                    self.particles.push(new Particle(x, y, hue));
                }
            };

            /*=============================================================================*/
            /* Update Particles
            /*=============================================================================*/
            self.updateParticles = function(){
                var i = self.particles.length;
                while(i--){
                    var p = self.particles[i];
                    p.update(i);
                }
            };

            /*=============================================================================*/
            /* Draw Particles
            /*=============================================================================*/
            self.drawParticles = function(){
                var i = self.particles.length;
                while(i--){
                    var p = self.particles[i];
                    p.draw();
                }
            };

            /*=============================================================================*/
            /* Firework Constructor
            /*=============================================================================*/
            var Firework = function(startX, startY, targetX, targetY){
                this.x = startX;
                this.y = startY;
                this.startX = startX;
                this.startY = startY;
                this.hitX = false;
                this.hitY = false;
                this.coordLast = [
                    {x: startX, y: startY},
                    {x: startX, y: startY},
                    {x: startX, y: startY}
                ];
                this.targetX = targetX;
                this.targetY = targetY;
                this.speed = self.fworkSpeed;
                this.angle = Math.atan2(targetY - startY, targetX - startX);
                this.shockwaveAngle = Math.atan2(targetY - startY, targetX - startX)+(90*(Math.PI/180));
                this.acceleration = self.fworkAccel/100;
                this.hue = self.currentHue;
                this.brightness = app.rand(50, 80);
                this.alpha = app.rand(50,100)/100;
                this.lineWidth = self.lineWidth;
                this.targetRadius = 1;
            };

            Firework.prototype.update = function(index){
                self.ctx.lineWidth = this.lineWidth;

                var vx = Math.cos(this.angle) * this.speed,
                    vy = Math.sin(this.angle) * this.speed;
                this.speed *= 1 + this.acceleration;
                this.coordLast[2].x = this.coordLast[1].x;
                this.coordLast[2].y = this.coordLast[1].y;
                this.coordLast[1].x = this.coordLast[0].x;
                this.coordLast[1].y = this.coordLast[0].y;
                this.coordLast[0].x = this.x;
                this.coordLast[0].y = this.y;

                if(self.showTarget){
                    if(this.targetRadius < 8){
                        this.targetRadius += .25 * self.dt;
                    } else {
                        this.targetRadius = 1 * self.dt;
                    }
                }

                if(this.startX >= this.targetX){
                    if(this.x + vx <= this.targetX){
                        this.x = this.targetX;
                        this.hitX = true;
                    } else {
                        this.x += vx * self.dt;
                    }
                } else {
                    if(this.x + vx >= this.targetX){
                        this.x = this.targetX;
                        this.hitX = true;
                    } else {
                        this.x += vx * self.dt;
                    }
                }

                if(this.startY >= this.targetY){
                    if(this.y + vy <= this.targetY){
                        this.y = this.targetY;
                        this.hitY = true;
                    } else {
                        this.y += vy * self.dt;
                    }
                } else {
                    if(this.y + vy >= this.targetY){
                        this.y = this.targetY;
                        this.hitY = true;
                    } else {
                        this.y += vy * self.dt;
                    }
                }

                if(this.hitX && this.hitY){
                    // var randExplosion = rand(0, 9);
                    let that = this
                    // setTimeout(() => {
                        self.createParticles(that.targetX, that.targetY, that.hue);
                    // }, 150);
                    self.fireworks.splice(index, 1);
                }
            };

            Firework.prototype.draw = function(){
                self.ctx.lineWidth = this.lineWidth;

                var coordRand = (app.rand(1,3)-1);
                self.ctx.beginPath();
                self.ctx.moveTo(Math.round(this.coordLast[coordRand].x), Math.round(this.coordLast[coordRand].y));
                self.ctx.lineTo(Math.round(this.x), Math.round(this.y));
                self.ctx.closePath();
                self.ctx.strokeStyle = 'hsla('+this.hue+', 100%, '+this.brightness+'%, '+this.alpha+')';
                self.ctx.stroke();

                if(self.showTarget){
                    self.ctx.save();
                    self.ctx.beginPath();
                    self.ctx.arc(Math.round(this.targetX), Math.round(this.targetY), this.targetRadius, 0, Math.PI*2, false)
                    self.ctx.closePath();
                    self.ctx.lineWidth = 1;
                    self.ctx.stroke();
                    self.ctx.restore();
                }

                if(self.showShockwave){
                    self.ctx.save();
                    self.ctx.translate(Math.round(this.x), Math.round(this.y));
                    self.ctx.rotate(this.shockwaveAngle);
                    self.ctx.beginPath();
                    self.ctx.arc(0, 0, 1*(this.speed/5), 0, Math.PI, true);
                    self.ctx.strokeStyle = 'hsla('+this.hue+', 100%, '+this.brightness+'%, '+app.rand(25, 60)/100+')';
                    self.ctx.lineWidth = this.lineWidth;
                    self.ctx.stroke();
                    self.ctx.restore();
                }
            };

            /*=============================================================================*/
            /* Create Fireworks
            /*=============================================================================*/
            self.createFireworks = function(startX, startY, targetX, targetY, force){

                if (app.windowIsVisible && app.focus) {
                    if (!app.lockFire || force) {
                        self.fireworks.push(new Firework(startX, startY, targetX, targetY));
                    }
                }
            };

            /*=============================================================================*/
            /* Update Fireworks
            /*=============================================================================*/
            self.updateFireworks = function(){
                var i = self.fireworks.length;
                while(i--){
                    var f = self.fireworks[i];
                    f.update(i);
                }
            };

            /*=============================================================================*/
            /* Draw Fireworks
            /*=============================================================================*/
            self.drawFireworks = function(){
                var i = self.fireworks.length;
                while(i--){
                    var f = self.fireworks[i];
                    f.draw();
                }
            };

            /*=============================================================================*/
            /* Events
            /*=============================================================================*/
            self.bindEvents = function(){
                // $(window).on('resize', function(){
                window.onresize = function() {
                    clearTimeout(self.timeout);
                    self.timeout = setTimeout(function() {
                        self.ctx.lineCap = 'round';
                        self.ctx.lineJoin = 'round';
                    }, 100);
                };

                // $(self.canvas).on('mousedown', function(e){
                let fireEvent = null;
                self.canvas.addEventListener('mousedown', function(e){
                    // var randLaunch = rand(0, 5);
                    self.mx = e.pageX - self.canvasContainer.offsetLeft;
                    self.my = e.pageY - self.canvasContainer.offsetTop;
                    self.currentHue = app.rand(self.hueMin, self.hueMax);
                    self.createFireworks(self.cw/2, self.ch, self.mx, self.my);

                    // $(self.canvas).on('mousemove.fireworks', function(e){
                    fireEvent = self.canvas.addEventListener('mousemove.fireworks', function(e){
                        // var randLaunch = rand(0, 5);
                        self.mx = e.pageX - self.canvasContainer.offsetLeft;
                        self.my = e.pageY - self.canvasContainer.offsetTop;
                        self.currentHue = app.rand(self.hueMin, self.hueMax);
                        self.createFireworks(self.cw/2, self.ch, self.mx, self.my);
                    });

                });

                // $(self.canvas).on('mouseup', function(){
                self.canvas.addEventListener('mouseup', function(){
                    self.canvas.removeEventListener('mousemove.fireworks', fireEvent);
                });

            }

            /*=============================================================================*/
            /* Clear Canvas
            /*=============================================================================*/
            self.clear = function(){
                self.particles = [];
                self.fireworks = [];
                self.ctx.clearRect(0, 0, self.cw, self.ch);
            };

            /*=============================================================================*/
            /* Delta
            /*=============================================================================*/
            self.updateDelta = function(){
                var newTime = Date.now();
                self.dt = (newTime - self.oldTime)/16;
                self.dt = (self.dt > 5) ? 5 : self.dt;
                self.oldTime = newTime;
            }

            /*=============================================================================*/
            /* Main Loop
            /*=============================================================================*/
            self.canvasLoop = function(){
                window.requestAnimFrame(self.canvasLoop, self.canvas);
                self.updateDelta();
                self.ctx.globalCompositeOperation = 'destination-out';
                self.ctx.fillStyle = 'rgba(0,0,0,'+self.clearAlpha/100+')';
                self.ctx.fillRect(0,0,self.cw,self.ch);
                self.ctx.globalCompositeOperation = 'lighter';
                self.updateFireworks();
                self.updateParticles();
                self.drawFireworks();
                self.drawParticles();
            };

            self.init();

        }

        let fworks = new Fireworks();
        this.fworks = fworks;


        //
        // set sections animation
        //
        const sections = document.querySelectorAll('.section');

        let canvas = document.querySelector('#canvas-container canvas'),
            cw = canvas.width,
            ch = canvas.height;

        sections.forEach((section, key) => {
            app.scrollTrigger = ScrollTrigger.create({
                trigger: section,
                start: "top 25%",
                end: "bottom 25%",
                onEnter: function() {
                    navEnter(key)
                },
                onEnterBack: function() {
                    let initialLaunchCount = 2;

                    while(initialLaunchCount--){
                        let targetX = app.rand((cw / 4), cw-(cw / 4))

                        fworks.createFireworks(cw/2, ch, targetX, app.rand(50, ch/3)+50);
                    }

                    gsap.to(section, {opacity: 1, duration: .5, delay: 1});

                    navEnter(key)
                },
            });
        });

        function navEnter(key) {
            document.querySelectorAll('.nav-item').forEach((nav) => {
                nav.classList.remove('active')
            })
            document.querySelectorAll('.nav-item')[key].classList.add('active')

            gsap.to(document.querySelector('.nav'), {scrollTo: {x: document.querySelectorAll('.nav-item')[key].offsetLeft - 20}, duration: .4})
        }


        //
        // end parallax
        //
        gsap.fromTo('.end-confetti',
            {
                yPercent: 10
            },
            {
                yPercent: 0,
                ease: 'none',
                scrollTrigger: {
                    trigger: 'body',
                    scrub: true
                },
            }
        )


        //
        // blur/focus for fireworks
        //
        window.addEventListener('blur', function() {
            app.focus = false
        })
        window.addEventListener('focus', function() {
            app.focus = true
        })


        //
        // set scroll tl
        //
        let reverseSections = []

        sections.forEach((section) => {
            reverseSections.unshift(section)
        })

        let scrollTl = gsap.timeline({paused: true, onComplete: function() {
            document.querySelector('body').classList.add('scroll')

            let initialLaunchCount = 2;

            while(initialLaunchCount--){
                fworks.createFireworks(cw/2, ch, app.rand(50, cw-50), app.rand(50, ch/2)+50);
            }

            if (!app.mobileDetect.isMobile()) {
                setInterval(() => {
                    let initialLaunchCount = 2;

                    while(initialLaunchCount--){
                        fworks.createFireworks(cw/2, ch, app.rand(50, cw-50), app.rand(50, ch/2)+50, true);
                    }
                }, 5000);
            }

            gsap.to('.start .button, .start .start-to-scroll, .nav', {opacity: 1, 'pointer-events': 'all', duration: .5, delay: .65})
            gsap.set('.end-ml', {display: 'none'})

            document.querySelector('.button.button--space').classList.add('hide')

            app.lockFire = true
        }})

        reverseSections.forEach((section, key) => {
            let offset = section.offsetTop - 100

            if (key > 0) {
                scrollTl.to(window, {scrollTo: offset, delay: .75, duration: 1.5, ease: 'power4.inOut'})
            } else {
                scrollTl.to(window, {scrollTo: offset, duration: 1.5, ease: 'power4.inOut'})
            }
        })

        scrollTl.addLabel('top')
        scrollTl.to(window, {scrollTo: 0, duration: 1.5, delay: .75, ease: 'power4.inOut'})

        this.scrollTl = scrollTl

        document.addEventListener('keydown', function(e) {
            if (e.code == 'Space') {
                e.preventDefault();

                scrollTl.play()

                document.querySelector('.button.button--space').classList.add('active')

                gsap.to('.button.button--space, .blur', {opacity: 0, delay: .4})
            }
        })

        document.addEventListener('keyup', function(e) {
            if (e.code == 'Space') {
                e.preventDefault();

                scrollTl.pause()

                document.querySelector('.button.button--space').classList.remove('active')

                gsap.to('.button.button--space, .blur', {opacity: 1, delay: 2})
            }
        })

        if (app.mobileDetect.isMobile()) {
            document.querySelector('.button.button--space .button-content').innerHTML = "Maintenez appuyé"

            document.querySelector('.button.button--space').addEventListener('touchstart', function(e) {
                e.preventDefault();

                scrollTl.play()

                document.querySelector('.button.button--space').classList.add('active')
            })

            document.querySelector('.button.button--space').addEventListener('touchend', function(e) {
                e.preventDefault();

                scrollTl.pause()

                document.querySelector('.button.button--space').classList.remove('active')
            })
        }


        //
        // fixed button
        //
        let buttonSpace = document.querySelector('.button.button--space'),
            buttonOffset = app.getOffset(buttonSpace)

        window.addEventListener('scroll', function() {
            let scroll = window.scrollY + window.innerHeight,
                offset = buttonOffset.top + buttonSpace.offsetHeight

            if (scroll <= offset) {
                buttonSpace.classList.add('fixed')
            } else {
                buttonSpace.classList.remove('fixed')
            }
        })


        //
        // button wiggle
        //
        let btnWiggle = gsap.timeline({repeat: -1, repeatDelay: 2.5});
            btnWiggle.fromTo('.button.button--space',
            {
                x: 10
            },
            {
                x: -10,
                duration: .075,
                ease: 'none',
                yoyo: true,
                repeat: 10
            })
            btnWiggle.set('.button.button--space', {x: 0})
    },
    methods: {
        rand: function (rMi, rMa) {
            return ~~((Math.random()*(rMa-rMi+1))+rMi)
        },
        kickOffTheFestivities: function (e) {
            e.preventDefault()

            this.scrollTl.play()
        },
        scrollToSlide: function(index) {
            let sections = document.querySelectorAll('.section')

            gsap.to(window, {scrollTo: sections[index].offsetTop - 60, duration: 1, ease: 'power4.inOut'})
        },
        getOffset: function (el) {
            var rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
        }
    }
}
</script>

<style scoped lang="scss">
    .main {
        .fireworks, #canvas-container {
            position: fixed;
            inset: 0;
            z-index: 1;

            width: 100vw;
            height: 100vh;

            pointer-events: none;

            canvas {
                position: sticky;
                inset: 0;

                width: 100%;
                height: 100%;

                z-index: 1;
            }
        }

        .section {
            position: relative;

            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            width: 100vw;

            margin: 60px 0;

            opacity: 0;

            &--left {
                max-width: 64%;
            }

            &--right {
                max-width: 64%;

                margin: {
                    left: 36%;
                }
            }

            &-date {
                color: var(--red);
                font-size: 16px;
                text-transform: uppercase;

                margin: {
                    bottom: 16px
                }
            }

            &-text {
                line-height: 24px;

                .ml {
                    font-size: 12px;
                }
            }

            .button {
                margin: {
                    top: 20px;
                }
            }

            @media screen and (max-width: 576px) {
                max-width: 100% !important;
                min-height: 0;

                margin: 0 !important;
                padding: 64px 20px;

                &-text {
                    line-height: 17px;

                    br {
                        display: none;
                    }
                }
            }
        }

        .end, .start {
            position: relative;

            width: 100vw;
            height: 100vh;

            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            padding: 0 15px;

            overflow: hidden;

            &-image, .title, &-text, &-ml, &-home, .button--space {
                z-index: 2;
            }

            &-background {
                position: absolute;
                top: 0;
                left: -7vw;
                z-index: 1;

                width: 110vw;
                height: calc(100vh + 200px);

                background-image: url('../assets/img/KV_140ANS.jpg');
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover;

                &:before {
                    content: '';

                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 1;

                    width: 110vw;
                    height: 200px;

                    background-image: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
                }

                &:after {
                    content: '';

                    position: absolute;
                    inset: 0;

                    background-color: rgba(0, 0, 0, .3);
                }
            }

            &-confetti {
                position: fixed;
                inset: 0;
                z-index: -1;

                // background-image: url('../assets/img/confetti.svg');
                // background-position: center;
                // background-repeat: no-repeat;
                // background-size: cover;

                // box-shadow: inset 0px 0px 40px 40px var(--burgundy);

                pointer-events: none;

                &-left {
                    position: absolute;
                    top: -10%;
                    left: 0;
                    bottom: -10%;

                    width: 20vw;

                    background-image: url('../assets/img/confetti-left.svg');
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: contain;
                }

                &-right {
                    position: absolute;
                    top: -10%;
                    right: 0;
                    bottom: -10%;

                    width: 20vw;

                    background-image: url('../assets/img/confetti-right.svg');
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: contain;
                }
            }

            &-image {
                max-width: 320px;

                margin: {
                    bottom: 30px;
                }
            }

            &-title {
                margin: {
                    bottom: 40px;
                }
            }

            &-text {
                color: white;
                font-weight: bold;
                line-height: 24px;

                margin: {
                    bottom: 40px;
                }
            }

            &-ml {
                font-size: 14px;

                margin: {
                    bottom: 20px;
                }
            }

            &-to-scroll {
                position: absolute;
                left: 0;
                right: 0;
                bottom: 20px;

                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;

                width: 30px;

                margin: auto;

                cursor: pointer;

                opacity: 0;

                &:before {
                    content: '';

                    position: relative;

                    width: 20px;
                    height: 20px;

                    border: {
                        right: 2px solid var(--gold);
                        bottom: 2px solid var(--gold);
                    }

                    transform: rotate(45deg);

                    animation: toScroll 1s .9s ease-in infinite;
                }

                &:after {
                    content: '';

                    position: relative;

                    width: 20px;
                    height: 20px;

                    border: {
                        right: 2px solid var(--gold);
                        bottom: 2px solid var(--gold);
                    }

                    margin: {
                        top: -10px
                    }

                    transform: rotate(45deg);

                    animation: toScroll 1s ease-in infinite;
                }
            }

            @media screen and (max-width: 576px) {
                padding: 0 20px;

                &-confetti {
                    display: none;
                }

                &-image {
                    max-width: 250px;

                    margin: {
                        bottom: 20px;
                    }
                }

                &-title {
                    margin: {
                        bottom: 30px;
                    }
                }

                &-text {
                    line-height: 17px;

                    margin: {
                        bottom: 30px;
                    }

                    br {
                        display: none;
                    }
                }

                &-ml {
                    display: none
                }
            }
        }

        .nav {
            position: fixed;
            left: 5px;
            right: 5px;
            bottom: 5px;
            z-index: 5;

            display: flex;
            column-gap: 12px;

            opacity: 0;

            pointer-events: none;

            &-item {
                position: relative;
                z-index: 2;

                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;

                color: var(--white);
                font-size: 14px;
                font-weight: bold;
                text-transform: uppercase;

                padding: 10px 10px;

                // opacity: .6;

                background-color: var(--red);
                border-radius: 5px;

                transition: background-color .2s, opacity .2s;

                cursor: pointer;

                &:hover {
                    background-color: var(--dark-red);
                }

                &.active {
                    background-color: var(--gold);

                    opacity: 1;
                }
            }

            @media screen and (max-width: 576px) {
                overflow: auto;

                &:before {
                    position: fixed;

                    top: auto;

                    height: 40px;

                    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, .6));
                }

                &-item {
                    color: var(--white);

                    white-space: nowrap;
                }
            }
        }

        .start {
            &-home {
                position: absolute;
                top: 20px;
                left: 20px;

                color: white;
                font-size: 12px;
                text-transform: uppercase;

                display: flex;
                align-items: center;

                img {
                    margin: {
                        right: 14px
                    }
                }

                span {
                    margin: {
                        left: 5px
                    }

                    border: {
                        bottom: 2px solid var(--gold);
                    }
                }
            }

            &-background {
                &:before {
                    content: '';

                    position: absolute;
                    top: auto;
                    left: 0;
                    bottom: 198px;
                    z-index: 1;

                    width: 110vw;
                    height: 200px;

                    background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
                }

                &:after {
                    content: '';

                    position: absolute;
                    inset: 0;

                    background-color: rgba(0, 0, 0, .3);
                }
            }

            .title {
                color: var(--gold);
            }

            .button {
                position: fixed;
                top: 30px;
                right: 20px;

                z-index: 10;

                opacity: 0;
            }

            @media screen and (max-width: 576px) {
                &-home {
                    display: none;
                }
            }
        }

        .end {
            .title {
                margin: {
                    top: 40px
                }
            }

            &-image, .title, &-text, &-ml, .button--space {
                z-index: 2;
            }

            &-ml {
                color: white;
                font-weight: bold;
            }

            .button {
                display: none;

                &--space {
                    display: block;
                }
            }

            @media screen and (max-width: 576px) {
                padding: {
                    top: 20px
                }

                .button {
                    width: 220px;
                    max-width: 220px;
                }
            }
        }

        .blur {
            position: fixed;
            left: 20vh;
            right: 20vh;
            bottom: 0;
            z-index: 0;

            height: 20vh;

            background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255,  .9));

            clip-path: ellipse(50% 100% at 50% 100%);

            opacity: 0;
        }
    }

    @keyframes toScroll {
        0% {
            top: 0
        }
        50% {
            top: 4px
        }
        100% {
            top: 0
        }
    }
</style>
